import React from 'react'
import Svg from './Svg'
export const SvgPermits = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M24 18V0H7.5v1.732l-3.929.552.255 1.815L0 5.197l4.961 17.302 15.283-4.382.838-.118H24zM9 1.5h13.5v15H9v-15zM7.5 3.105V18h3.814l-4.08.574L5.107 3.441 7.5 3.105zM5.893 20.818L1.681 6.129l2.337-.67 2.058 14.65 4.496-.632-4.679 1.342zM10.5 3H21v1.5H10.5zm0 3H21v1.5H10.5zm0 3H21v1.5H10.5zm0 3H18v1.5h-7.5z" />
  </Svg>
))
SvgPermits.isIcon = true
export default SvgPermits
